import React, {Component} from "react";

import * as types from "../../../../constants/componentTypes";

import ModuleModal from "../global/modal/ModuleModal";
import VersionModal from "../global/modal/VersionModal";
import DatabaseListModal from "../global/modal/DatabaseListModal";
import DeleteOrderModal from "./modal/DeleteOrderModal";
import MachineFillCanisterHistoryModal from "./modal/MachineFillCanisterHistoryModal";
import MachineRestartRedlikeModal from "./modal/MachineRestartRedlikeModal";
import MachineRebootPCModal from "./modal/MachineRebootPCModal";
import MachineNoteModal from "./modal/MachineNoteModal";
import AdditionalPrintModal from "./modal/AdditionalPrintModal";
import OrderNotificationModal from "../../../../containers/modal/OrderNotificationModal";
import DebugModal from "../../../global/modal/DebugModal";
import StockModal from "../../../../containers/apps/gamma/machine/StockModal";
import AddColorantPackagesToStockModal from "./modal/AddColorantPackagesToStockModal";
import ColorantPackagesConfirmOrderModal from "./modal/ColorantPackagesConfirmOrderStockModal";
import EditColorantPackageInStockModal from "./modal/EditColorantPackageInStockModal";
import ManualOrderStockModal from "./modal/ManualOrderStockModal";
import RemovePackageFromStockConfirmModal from "./modal/RemovePackageFromStockConfirmModal";

export default class Modal extends Component {
    render() {
        switch (this.props.type) {
            case types.ADD_COLORANT_PACKAGES_TO_STOCK_MODAL:
                return <AddColorantPackagesToStockModal {...this.props} />;
            case types.COLORANT_PACKAGES_CONFIRM_ORDER_STOCK_MODAL:
                return <ColorantPackagesConfirmOrderModal {...this.props} />;
            case types.EDIT_COLORANT_PACKAGE_IN_STOCK_MODAL:
                return <EditColorantPackageInStockModal {...this.props} />;
            case types.INTERGAMMA_MODULE_MODAL:
                return <ModuleModal {...this.props} />;
            case types.INTERGAMMA_SW_VERSIONS_MODAL:
                return <VersionModal {...this.props} />;
            case types.INTERGAMMA_DATABASE_LIST_MODAL:
                return <DatabaseListModal {...this.props} />;
            case types.INTERGAMMA_DELETE_ORDER_MODAL:
                return <DeleteOrderModal {...this.props} />;
            case types.INTERGAMMA_MACHINE_FILL_CANISTER_HISTORY_MODAL:
                return <MachineFillCanisterHistoryModal {...this.props} />;
            case types.INTERGAMMA_MACHINE_RESTART_REDLIKE_MODAL:
                return <MachineRestartRedlikeModal {...this.props} />;
            case types.INTERGAMMA_MACHINE_REBOOT_PC_MODAL:
                return <MachineRebootPCModal {...this.props} />;
            case types.INTERGAMMA_NOTE_MODAL:
                return <MachineNoteModal {...this.props} />;
            case types.INTERGAMMA_ADDITIONAL_PRINT_MODAL:
                return <AdditionalPrintModal {...this.props} />;
            case types.MANUAL_ORDER_STOCK_MODAL:
                return <ManualOrderStockModal {...this.props} />;
            case types.ORDER_NOTIFICATION_MODAL:
                return <OrderNotificationModal {...this.props} />;
            case types.REMOVE_PACKAGE_FROM_STOCK_CONFIRM_MODAL:
                return <RemovePackageFromStockConfirmModal {...this.props} />;
            case types.STOCK_MODAL:
                return <StockModal {...this.props} />;
            case types.DEBUG_MODAL:
                return <DebugModal {...this.props} />;
            default:
                return <div />;
        }
    }
}
